import { z } from 'zod'
import { Model } from './architecture'

export const EmailValidation = z.object({
  value: z.string({ required_error: '[Email] value is required' }),
})

export class Email extends Model {
  static create({ value }: z.infer<typeof EmailValidation>) {
    EmailValidation.parse({ value })
    return new Email(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
